import { $api } from "@/services/api";
import store from "@/store";
const state = {
  totalPaymentApproval: 0,
};

const getters = {
  totalPaymentApproval: (state) => state.totalPaymentApproval,
};

const mutations = {
  async settotalPaymentApproval(state, total) {
    state.totalPaymentApproval = total;
  },
};

const actions = {
  async gettotalPaymentApproval({ commit }) {
    try {
      const paymentApprovalItemRes = await $api.v_payment_approval_items.get({
        aduser: store.getters.user.userName,
        status: "Waiting",
        is_active: true,
      });

      commit("settotalPaymentApproval", paymentApprovalItemRes.total);
    } catch (error) {
      console.error(error?.message);
      commit("settotalPaymentApproval", 0);
    }
  },
};

export default { state, getters, mutations, actions };
